import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material";
import { FilterDialogOptions } from "./filter-dialog.defs";

@Component({
	selector: 'app-appointment-filter',
	templateUrl: 'filter-dialog.component.html',
	styleUrls: ['./filter-dialog.component.css'],
})
export class AppointmentFilterComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: FilterDialogOptions,
	) {
		
	}
}